import React, { useEffect, useRef } from 'react';

const Modal = ({ open, title, children, onClose, actions, size = 'sm', disableAutoFocus = false }) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    if (open && dialogRef.current && !disableAutoFocus) {
      // store previously focused element
      const prev = document.activeElement;
      const el = dialogRef.current.querySelector('[data-autofocus]') || dialogRef.current;
      el.focus();
      const handleKey = (e) => {
        if (e.key === 'Escape') {
          e.stopPropagation();
          onClose?.();
        }
        if (e.key === 'Tab') {
          // focus trap
          const focusable = dialogRef.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
          const list = Array.from(focusable).filter(x => !x.disabled && x.offsetParent !== null);
          if (list.length === 0) return;
          const first = list[0];
            const last = list[list.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      };
      document.addEventListener('keydown', handleKey, true);
      return () => {
        document.removeEventListener('keydown', handleKey, true);
        if (prev && prev.focus) prev.focus();
      };
    }
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="sb-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="modal-title" onMouseDown={(e) => { if (e.target.classList.contains('sb-modal-overlay')) onClose?.(); }}>
      <div className={"sb-modal sb-modal-" + size} ref={dialogRef} tabIndex={-1}>
        {title && <h3 id="modal-title" className="sb-modal-title">{title}</h3>}
        <div className="sb-modal-body">{children}</div>
        {actions && <div className="sb-modal-actions">{actions}</div>}
        <button aria-label="Close" className="sb-modal-close" onClick={onClose}>×</button>
      </div>
    </div>
  );
};

export default Modal;
